<template>
    <svg width="23" height="23" viewBox="0 0 23 23" fill="current" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.21784 17.8313C8.4433 17.6058 8.56997 17.3 8.56997 16.9812C8.56997 16.6623 8.4433 16.3565 8.21784 16.1311L4.60313 12.5164L20.9696 12.5152C21.2809 12.5042 21.5758 12.3728 21.7922 12.1487C22.0085 11.9246 22.1295 11.6252 22.1295 11.3137C22.1295 11.0022 22.0085 10.7029 21.7922 10.4787C21.5758 10.2546 21.2809 10.1232 20.9696 10.1122L4.60313 10.1111L8.21784 6.49638C8.4433 6.27092 8.56997 5.96512 8.56997 5.64626C8.56997 5.32741 8.4433 5.02161 8.21784 4.79614C7.99237 4.57068 7.68658 4.44402 7.36772 4.44401C7.04886 4.44401 6.74307 4.57068 6.5176 4.79615L0.850143 10.4636C0.624677 10.6891 0.498013 10.9949 0.498013 11.3137C0.498013 11.6326 0.624677 11.9384 0.850143 12.1638L6.5176 17.8313C6.74307 18.0568 7.04886 18.1834 7.36772 18.1834C7.68658 18.1834 7.99237 18.0568 8.21784 17.8313Z" :fill="color"/>
    </svg>
</template>

<script>
    export default {
        name:"BackArrow",
        props: {
            color: {
                type: String,
                default: '#6B7E99'
            }
        },
    }
</script>